"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _RequiredOnboardingSelectors = require("pricing-pages-unified-ui/selectors/RequiredOnboardingSelectors");

var _ProductOwnershipSelectors = require("pricing-pages-unified-ui/selectors/ProductOwnershipSelectors");

var _RequiredOnboardingSection = _interopRequireDefault(require("pricing-pages-unified-ui/components/calculator/RequiredOnboardingSection"));

var _ItemConfigsSelectors = require("pricing-pages-unified-ui/selectors/ItemConfigsSelectors");

var HubCalcRequiredOnboardingSectionContainer = function HubCalcRequiredOnboardingSectionContainer(_ref) {
  var requiredOnboardingMerchId = _ref.requiredOnboardingMerchId,
      termId = _ref.termId,
      ownsProduct = _ref.ownsProduct;
  if (ownsProduct) return null;
  return _react.default.createElement(_RequiredOnboardingSection.default, {
    requiredOnboardingMerchId: requiredOnboardingMerchId,
    activeTermId: termId
  });
};

HubCalcRequiredOnboardingSectionContainer.propTypes = {
  requiredOnboardingMerchId: _propTypes.default.number,
  termId: _propTypes.default.number,
  ownsProduct: _propTypes.default.bool
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var merchandiseId = _ref2.merchandiseId,
      term = _ref2.term;
  return {
    requiredOnboardingMerchId: (0, _RequiredOnboardingSelectors.requiredOnboardingMerchIdSelector)(state, merchandiseId),
    ownsProduct: (0, _ProductOwnershipSelectors.ownsProductSelector)(state, merchandiseId),
    termId: (0, _ItemConfigsSelectors.termIdFromTermSelector)(state, term, merchandiseId)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(HubCalcRequiredOnboardingSectionContainer);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/HubCalcRequiredOnboardingSectionContainer.js
// module id = 814
// module chunks = 5 6